import { createUseContext } from '@boxcryptor-web/shared/react-hooks';
import * as React from 'react';

const FirstHeadingLevelContext = React.createContext<{ firstHeadingLevel: number | undefined }>({
  firstHeadingLevel: undefined,
});

export const useFirstHeadingLevelContext = createUseContext('FirstHeadingLevelContext', FirstHeadingLevelContext);

export const FirstHeadingLevelContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const firstHeadingLevel = { firstHeadingLevel: undefined };
  return <FirstHeadingLevelContext.Provider value={firstHeadingLevel}>{children}</FirstHeadingLevelContext.Provider>;
};
